import { EEstimationTargets } from '@cian/valuation-main-filters-widget';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useRunBeforePushSubscription } from './useRunBeforePushSubscription';
import { checkSuburbanEstimationExists } from '../../../actions/checkEstimationExists';
import { openSuburbanDataPaymentForm } from '../../../actions/dataPayment';
import { selectFilters } from '../../../selectors/selectFilters';
import { TThunkDispatch } from '../../../types/redux';

export function useHandleSuburbanSubmit() {
  const dispatch = useDispatch<TThunkDispatch>();
  const { pushEnabled, estimationTarget } = useSelector(selectFilters);

  const runBeforePushSubscription = useRunBeforePushSubscription();

  return React.useCallback(async () => {
    const redirectToDataPaymentWithSubscription = async () => {
      /** Подписываем на оценку, если тоггл включен, и только для квартир и загородки */
      let shouldSubscribe = Boolean(pushEnabled && estimationTarget !== EEstimationTargets.newbuilding);

      if (shouldSubscribe) {
        shouldSubscribe = await runBeforePushSubscription();
      }

      dispatch(openSuburbanDataPaymentForm({ pushNeed: shouldSubscribe }));
    };

    const isEstimationExists = await dispatch(checkSuburbanEstimationExists());

    if (!isEstimationExists) {
      return;
    }

    await redirectToDataPaymentWithSubscription();
  }, [dispatch, pushEnabled, estimationTarget, runBeforePushSubscription]);
}
